import React from 'react';
import step1 from '../assets/images/how-it-works-card-1.svg';
import step2 from '../assets/images/how-it-works-card-2.svg';
import step3 from '../assets/images/how-it-works-card-3.svg';
import step4 from '../assets/images/how-it-works-card-4.svg';

const steps = [
  {
    number: 1,
    title: 'Contact Us',
    description: 'Call our dedicated support team or reach out via WhatsApp for your maintenance needs.',
    icon: step1,
  },
  {
    number: 2,
    title: 'Purchase Credits',
    description: 'Buy service credits that can be used for various maintenance services.',
    icon: step2,
  },
  {
    number: 3,
    title: 'Schedule Service',
    description: 'Set up a convenient time for our verified professionals to visit your property.',
    icon: step3,
  },
  {
    number: 4,
    title: 'Completion',
    description: 'Receive confirmation with photos or videos once the service is completed to your satisfaction.',
    icon: step4,
  },
];

const HowItWorks = () => {
  return (
    <section className="how-it-works py-5">
      <div className="container bg-light rounded-5 p-5">
        <div className="text-center mb-5">
        <h2 className="fw-bold text-dark text-center display-6 mb-4">How It Works</h2>
        <p className="text-muted fs-5">
            A simple, transparent process to ensure your property is well-maintained with minimal effort on your part.
          </p>
        </div>

        <div className="row g-4">
          {steps.map((step, index) => (
            <div className="col-md-6 col-lg-3" key={index}>
              <div className="div-2 h-100 shadow-sm p-4 rounded-4 bg-white text-center hover-effect">
                <div className="step-number mx-auto mb-3">{step.number}</div>
                <div className="icon mx-auto mb-3 position-relative">
  <div className="icon-circle"></div>
  <img
    className="how-it-works-card position-absolute top-50 start-50 translate-middle"
    src={step.icon}
    alt={step.title}
  />
</div>

<h5
  className="fw-semibold text-center text-dark"
  style={{
    fontFamily: '"Plus Jakarta Sans", Helvetica, sans-serif',
    fontSize: '20px',
    lineHeight: '40px',
    letterSpacing: '0.2px',
    marginTop: '-1px'
  }}
>
  {step.title}
</h5>


                <p className="p text-muted">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
